import { useTranslations } from 'next-intl'

import { weekDays } from './openingHoursState'

export const useTranslatedWeekDays = () => {
	const t = useTranslations()
	return weekDays.map((day) => ({
		key: day,
		label: t(
			`generator__content_form_section__opening__hours_section__daynames__${day}`,
		),
	}))
}
